<script setup lang="ts">
import { Modal } from "@toruslabs/vue-components/Modal";
import { ref } from "vue";

import { Button } from "@/components/Button";
import CreditCardDialog from "@/components/CreditCardDialog";
import { Team } from "@/utils/interface";

defineProps<{
  selectedTeam: Team;
}>();

const creditCardDialog = ref(false);
const toggleCreditCardDialog = (show: boolean) => {
  creditCardDialog.value = show;
};
</script>

<template>
  <Modal
    :open="true"
    :border="false"
    :classes="{ modalContent: 'max-md:!h-auto', footer: 'justify-end', header: '!border-b !border-app-gray-200' }"
    :header-divider="true"
    :footer-divider="true"
    :clear-icon="false"
  >
    <template #header>
      <div class="font-bold">Add a payment method to continue</div>
    </template>

    <template #body>
      <div class="text-app-gray-500">You have existing projects that are on mainnet. To use mainnet projects, a payment method is necessary.</div>
      <div class="text-app-gray-500 font-semibold">You will not be charged unless you surpass the 1,000 free MAWs or activate any add-ons.</div>
    </template>

    <template #footer>
      <div class="text-lg font-semibold text-app-gray-900">
        <Button @click="toggleCreditCardDialog(true)">Add payment method</Button>
      </div>
    </template>
  </Modal>

  <CreditCardDialog :open="creditCardDialog" :selected-team-id="selectedTeam.id" @on-close="toggleCreditCardDialog(false)" />
</template>
